<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.studentRankLevelList.push"
  >
    <el-table-column label="ID" prop="id" width="70"/>
    <el-table-column label="等级名称" prop="level_name" width="120"/>
    <el-table-column label="上课次数区间" width="160">
      <template v-slot="{ row }">
        {{ row.min_hours }} ~ {{ row.max_hours === null ? '无上限' : row.max_hours }}
      </template>
    </el-table-column>
    <el-table-column label="颜色" width="120">
      <template v-slot="{ row }">
        <span class="level-color-box" :style="{ backgroundColor: row.color }">{{ row.color }}</span>
      </template>
    </el-table-column>
    <el-table-column label="等级图标" width="180">
      <template v-slot="{ row }">
        <img v-if="row.icon_url" class="level-icon" :src="row.icon_url" alt=""/>
        <span v-else class="info-color">--</span>
      </template>
    </el-table-column>
    <v-column-time/>
    <el-table-column label="操作" width="220">
      <template v-slot="{ row }">
        <v-list-button :to="RouteConfig.studentRankLevelEdit.to(row.id)"/>

        <v-list-button
          name="删除"
          icon="bin"
          @click="handleDelete(row)"
          :is-loading="isDeleting[row.id]"
          message="确定要删除此等级吗？"
          :is-last="true"
        />
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`student-rank-level-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>等级名称</span>
              <span>{{ v.level_name }}</span>
            </div>

            <div class="list-item-detail">
              <span>上课次数区间</span>
              <span>{{ v.min_hours }} ~ {{ v.max_hours === null ? '无上限' : v.max_hours }}</span>
            </div>

            <div class="list-item-detail">
              <span>颜色</span>
              <span>{{ v.color }}</span>
            </div>

            <div class="list-item-detail">
              <span>等级图标</span>
              <img v-if="v.icon_url" class="level-icon" :src="v.icon_url" alt=""/>
            </div>

            <div class="list-item-button">
              <v-list-button :to="RouteConfig.studentRankLevelEdit.to(v.id)"/>

              <v-list-button
                name="删除"
                icon="bin"
                @click="handleDelete(v)"
                :is-loading="isDeleting[v.id]"
                message="确定要删除此等级吗？"
                :is-last="true"
              />
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { getLegalQueryList } from '@/utils/formats';
import { index, destroy } from '@/api/student-rank-level';

export default {
  name: RouteConfig.studentRankLevelList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isDeleting: {},
    count: 0,
    list: [],
    queryList: {
      is_del: 0,
      page: 1,
      size: 10,
    },
  }),
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    async load(route = this.$route) {
      this.isLoading = true;
      getLegalQueryList(this.queryList, route.query);
      const { isError, data } = await index(this.queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count || 0;
      this.list = data.list || [];
    },
    async handleDelete({ id, update_time }) {
      if (!id || !Number.isInteger(update_time)) {
        return this.$message.warning('缺少等级信息，无法删除！');
      }

      this.isDeleting = { ...this.isDeleting, [id]: true };
      const { isError } = await destroy(id, { update_time });
      this.isDeleting = { ...this.isDeleting, [id]: false };
      if (isError) return;

      this.$message.success('删除成功');
      this.load();
    },
  },
};
</script>

<style scoped>
.level-color-box {
  display: inline-block;
  min-width: 60px;
  padding: 2px 6px;
  border-radius: 4px;
  color: #fff;
  text-align: center;
}
.level-icon {
  display: block;
  width: 100px;
  height: 40px;
  object-fit: contain;
}
</style>
